<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/material/inland',title:'订单管理'},{title:'内销订单'}]"/>
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目名称</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="q" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2" required="true">
                                <el-select v-model="q.id" @change="queryXiangmu()"
                                           placeholder="请选择" clearable>
                                    <el-option v-for="item in allProjectByUser"
                                               :key="item.id"
                                               :label="item.projectName"
                                               :value="item.id">
                                        {{ item.projectName }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="PO单" class="h-elformWrap-2" required="true">
                                <el-input v-model="this._user.username" placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="PO凭证" class="h-elformWrap-2" required="true">
                                <el-input v-model="q.orderMainContract" placeholder="自带出"></el-input>
                            </el-form-item>
							<el-form-item label="订单类型" class="h-elformWrap-2" required="true">
							    <el-select v-model="q.id" @change="queryXiangmu()"
							               placeholder="请选择" clearable>
							        <el-option v-for="item in allProjectByUser"
							                   :key="item.id"
							                   :label="item.projectName"
							                   :value="item.id">
							            {{ item.projectName }}
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="销售公司" class="h-elformWrap-2" required="true">
							    <el-input v-model="q.orderSubContract" placeholder="请先选择项目"></el-input>
							</el-form-item>
							<el-form-item label="分销渠道" class="h-elformWrap-2" required="true">
							    <el-input v-model="q.orderSubContract" placeholder="请先选择项目"></el-input>
							</el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="formInline" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="客户编号" class="h-elformWrap-2" required="true">
                                <el-select v-model="formInline.orderCategory" >
                                    <el-option label="内销订单" value="1"></el-option>
                                    <el-option label="外销订单" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                           <el-form-item label="联系人" class="h-elformWrap-2" required="true">
                              <el-input v-model="formInline.linkMan" placeholder="请先选择项目"></el-input>
                           </el-form-item>
						   <el-form-item label="客户地址" class="h-elformWrap-2" required="true">
						      <el-input v-model="formInline.linkAdress" placeholder="请先选择项目"></el-input>
						   </el-form-item>
						   <el-form-item label="联系电话" class="h-elformWrap-2" required="true">
						      <el-input v-model="formInline.zCode" placeholder="请先选择项目"></el-input>
						   </el-form-item>
						   <el-form-item label="计划发货日" class="h-elformWrap-2" required="true">
						      <div class="block">
						          <el-date-picker
						                  v-model="formInline.expectDate"
						                  type="date"
						                  placeholder="--选择--"
						                  :clearable=false>
						          </el-date-picker>
						      </div>
						   </el-form-item>
                           
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">项目产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                    type="selection"
                    width="70"
                    label="全选"
                    @change="getAllTotalPrice(multipleSelection)">
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="序号"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="materialCode"
                    label="物料编码"
                    width="100%">
                    <template slot-scope="scope" v-show="showHidden">
                        <el-input v-model="scope.row.materialCode" @change="getSingleOrder(scope.row)" placeholder="请输入"
                            class="h-tableInput" :disabled="showHidden2">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proModelCode"
                    label="物料描述"
					:show-overflow-tooltip="true"
                    >
                </el-table-column>
                <el-table-column
                    prop="proNumber"
                    label="订单数量"
                    
                    :rules="[
                                { required: true, message: '请输入排序名称'},
                                { type: 'number', message: '必须为数字值',trigger: 'change'}
                            ]">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber" @change="getTotalPrice(scope.row)"
                            placeholder="请输入"
                            class="h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="proBenchmarkPrice"
                    label="价格"
                    >
                </el-table-column>
                <el-table-column
                    prop="specialPrice"
                    label="特价"
                    >
                </el-table-column>
                
                <el-table-column
                    prop="extraPrice"
                    label="合计金额"
                    >
                </el-table-column>
                <el-table-column
                    prop="finalPrice"
                    label="佣金"
                   >
                </el-table-column>
                
              
            </el-table>
            <div style="background-color: rgb(94, 182, 233);" v-if="showHidden" @click="newZen">
                <img src="../../../assets/images/pimg/jiahao.png" alt="">
            </div>
            <div class="jieguo">
                <span class="bizhong">币种</span>
                <span class="renminbi">{{ currency }}</span>
                <span class="dingdan">订单总价</span>
                <span class="yuan">{{ allTotalPrice }}</span>
                <span class="xianjin">现金余额</span>
                <span class="money">{{ cashBalance }}</span>
                <span class="xianjin">现金占用</span>
                <span class="money">{{ cashOccupy }}</span>
                <span class="xianjin">信贷余额</span>
                <span class="zhangqi">{{ creditBalance }}</span>
                <span class="xianjin">信贷占用</span>
                <span class="zhangqi">{{ creditOccupy }}</span>
                <span class="jiazhi">净价值</span>
                <span class="make">￥5000</span>
            </div>
        </div>
        <div class="h-pagination2 h-pageCenter">
            <pagination :page="q" @query="queryXiangmu"/>
        </div>
        <div class="anniu">
            <el-row>
                <a href="/dingd/material/inland">
                    <el-button class="quxiao" style="margin-right:10px;">取消</el-button>
                </a>
                <el-button class="zancun" @click="createNewOrder(10)">暂存</el-button>
                <el-button class="queren" @click="createNewOrder(20)">确认提交</el-button>
            </el-row>
        </div>
        <areaSelect :dialogFormVisible="false"></areaSelect>
    </div>
</template>
<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }
    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {
        width: 100px;
    }

    .bizhong, 
    .dingdan,
    .xianjin, 
    .jiazhi{
        width: 8%;
        text-align: center;
    }
    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }

    .renminbi, .yuan, .money, .zhangqi, .make{
        width: 10%;
        text-align: center;
       

    }
    .bizhong,
    .renminbi,
    .dingdan,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding:10px 0;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
        margin-top: 12px;
        width: 100%;
        padding-right: 20px;
       
    }
    span {
        color: white;
        position: relative;
        top: -12px;
        left: 20px;
        font-size: 14px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }
    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

    .bbbb {
        margin: 20px 20px 0 20px;
    }

    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }

</style>

<script>
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        //页面加载前事件
        created() {
          
        },

        methods: {
            newZen() {
                var objectList = {
                    materialCode: '',
                    proModelCode: '',
                    proNumber: '',
                    proBenchmarkPrice: '',
                    specialPrice: '',
                    isStockUp: '',
                    spare3: '',
                    extraPrice: '',
                    finalPrice: '',
                    totalPrice: '',
                    spare1: '',
                    contactName: '',
                    toAddress: '',
                    receivedTime: ''
                }
                this.tableData2.push(objectList)
            },
            mounted() {
                //  this.queryXiangmu();
            },
        },

        data() {
            return {
                showHidden: true,
                showHidden2: false,
                objectName: '',
                //分销渠道
                options: [{
                    value: '00',
                    label: '通用分销渠道'
                }, {
                    value: 'X1',
                    label: '香港外销渠道'
                }, {
                    value: 'Z1',
                    label: '上海直销渠道',
                    children: [{
                        value: 'ZSH1',
                        label: '采购本部',
                    }, {
                        value: 'ZSH2',
                        label: '第三方采购',
                    }, {
                        value: 'ZSH3',
                        label: '第三方销售',
                    }],
                }],
                selectedOptions: [],

                //sap订单参数
                orderCategory: '',


                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },

                cflag: false,
                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currency: '',
                expectTime: '',

                //查询属性
                q: {
                    id: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                labelPosition: 'left',
                formInline: {
                    orderCategory: '',
                    linkMan: '',
                    linkAdress: '',
                    zCode: '',
                },
                multipleSelection: [],
                //创建订单数据
                tableData: {
                    orderStatus: 1,
                    orderProjectCode: '',
                    orderData: {
                        currencyCode: '',
                        orderCategory: '内销订单',
                        saleGroupCode: '',
                        disChannelCode: '',
                        zCode: '',
                    },
                    orderProductList: [],
                },
                tableData2: [],
                //根据用户id查询出的所有项目
                allProjectByUser: [],
                clickActive: 1,

                
            };
        },
    }

</script>


